import { createSelector } from '@reduxjs/toolkit';
import { getProfileState } from './getProfileState';

export const getIsUserAgentFromInvitation = createSelector(
  getProfileState,
  (state) => state?.isUserAgentFromInvitation
);
